import { render, staticRenderFns } from "./ResellerManage.vue?vue&type=template&id=77bde018&"
import script from "./ResellerManage.vue?vue&type=script&lang=js&"
export * from "./ResellerManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports